import React, { useState, useRef } from 'react';
import styled from 'styled-components';
import { Icon, IconColour } from './icon';
import { DropItems } from './dropItems';
import { Box, Text } from 'rebass/styled-components';
import { DropdownItemsType } from 'util/types';

const Container = styled(Box)<{ width: string }>`
  min-width: ${(p) => p.width};
  width: ${(p) => p.width};
  position: relative;
`;

const TextComponent = styled(Text)<{ colour: 'grey' | 'white'; highlighted: boolean }>`
  flex-grow: 1;
  user-select: none;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: ${(p) => (p.colour === 'grey' ? '#16181D' : p.theme.colors.white)};
`;

// UI refresh: rounded control and menu, matching the rest of the app.
const Top = styled.div<{ colour: 'grey' | 'white' }>`
  width: 100%;
  height: 40px;
  box-sizing: border-box;
  background-color: ${(p) => (p.colour === 'grey' ? '#FFFFFF' : 'transparent')};
  border: 1px solid ${(p) => (p.colour === 'grey' ? '#DADDE2' : p.theme.colors.white)};
  border-radius: 10px;
  padding: 0 12px;
  cursor: pointer;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: 14px;
  :hover {
    border-color: ${(p) => (p.colour === 'grey' ? '#16181D' : p.theme.colors.secondary)};
  }
`;

const Options = styled.div`
  display: block;
  position: absolute;
  margin-top: 4px;
  background-color: #ffffff;
  width: 100%;
  border: 1px solid #e4e6ea;
  border-radius: 10px;
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.14);
  z-index: 20;
  max-height: 60vh;
  overflow-y: auto;
  padding: 4px;
  box-sizing: border-box;
`;

const Select = styled.div<{ colour: 'grey' | 'white' }>`
  width: 100%;
  position: relative;
  display: inline-block;
`;

type Props = {
  selected: DropdownItemsType;
  menuItems: DropdownItemsType[];
  onSelect(item: DropdownItemsType): void;
  width: string;
  style?: 'grey' | 'white';
};

export const DropDownMenu: React.FC<Props> = ({ selected, menuItems, onSelect, width, style = 'grey' }) => {
  const containerRef = useRef(null);
  const [open, setOpen] = useState(false);

  const itemClick = (item: DropdownItemsType) => {
    onSelect(item);
    setOpen(false);
  };

  return (
    <Container width={width} className="archy-dropdown">
      <Select colour={style}>
        <Top onClick={() => setOpen(!open)} colour={style} ref={containerRef}>
          <TextComponent highlighted={selected.value === 'master'} colour={style}>
            {selected.label}
          </TextComponent>
          <Icon
            style={'down'}
            onClick={() => {}}
            colour={style === 'grey' ? IconColour.grey : IconColour.secondary}
            noBox={true}
          />
        </Top>
        {open && (
          <Options>
            <DropItems
              menuItems={menuItems}
              onSelect={itemClick}
              close={() => setOpen(false)}
              containerRef={containerRef.current! as HTMLDivElement}
            />
          </Options>
        )}
      </Select>
    </Container>
  );
};
